import { render } from "./TableButtons.vue?vue&type=template&id=311d8bb9&ts=true"
import script from "./TableButtons.vue?vue&type=script&lang=ts"
export * from "./TableButtons.vue?vue&type=script&lang=ts"

import "./TableButtons.vue?vue&type=style&index=0&id=311d8bb9&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__